var _style, _g, _g2, _g3, _g4, _g5, _g6;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg06BankingApp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#EBEBEB;}\r\n\t.st1{fill:#E0E0E0;}\r\n\t.st2{fill:#F5F5F5;}\r\n\t.st3{fill:#042b62;}\r\n\t.st4{opacity:0.4;fill:#FFFFFF;enable-background:new    ;}\r\n\t.st5{opacity:0.2;enable-background:new    ;}\r\n\t.st6{fill:#263238;}\r\n\t.st7{opacity:0.7;fill:#FFFFFF;enable-background:new    ;}\r\n\t.st8{opacity:0.6;fill:#FFFFFF;enable-background:new    ;}\r\n\t.st9{opacity:0.7;}\r\n\t.st10{fill:#FFFFFF;}\r\n\t.st11{opacity:0.5;fill:#FFFFFF;enable-background:new    ;}\r\n\t.st12{fill:#E4897B;}\r\n\t.st13{opacity:0.2;fill:#FFFFFF;enable-background:new    ;}\r\n\t.st14{fill:#DE5753;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-2"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 382.4,
    className: "st0",
    width: 500,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 416.8,
    y: 398.5,
    className: "st0",
    width: 33.1,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 322.5,
    y: 401.2,
    className: "st0",
    width: 8.7,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 396.6,
    y: 389.2,
    className: "st0",
    width: 19.2,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.5,
    y: 390.9,
    className: "st0",
    width: 43.2,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104.6,
    y: 390.9,
    className: "st0",
    width: 6.3,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.5,
    y: 395.1,
    className: "st0",
    width: 93.7,
    height: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M237,337.8H43.9c-3.1,0-5.7-2.6-5.7-5.7V60.7c0-3.1,2.6-5.7,5.7-5.7H237c3.2,0,5.7,2.6,5.7,5.7c0,0,0,0,0,0 v271.4C242.7,335.2,240.2,337.8,237,337.8z M43.9,55.2c-3,0-5.5,2.4-5.5,5.5v271.4c0,3,2.4,5.5,5.5,5.5H237c3,0,5.5-2.4,5.5-5.5 V60.7c0-3-2.4-5.5-5.5-5.5H43.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M453.3,337.8H260.2c-3.2,0-5.7-2.6-5.7-5.7V60.7c0-3.1,2.6-5.7,5.7-5.7h193.1c3.1,0,5.7,2.5,5.7,5.7v271.4 C459,335.2,456.5,337.8,453.3,337.8z M260.2,55.2c-3,0-5.5,2.4-5.5,5.5v271.4c0,3,2.4,5.5,5.5,5.5h193.1c3,0,5.5-2.4,5.5-5.5V60.7 c0-3-2.4-5.5-5.5-5.5H260.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M386.8,126.5l9,6.6c-54.5,74.6-123,119.3-203.7,132.6c-57,9.4-100.8-0.9-107.6-2.6v20.6 c19.5,4.1,39.3,6.1,59.2,6c17,0,33.9-1.4,50.7-4.1c38.7-6.3,75.8-19.8,109.5-39.9c40.5-24.1,76.8-58,108-100.7l8.9,6.5l0.1-35.8 L386.8,126.5z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 85.5,
    y: 291.7,
    className: "st0",
    width: 9,
    height: 90.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.2,
    y: 295.7,
    className: "st0",
    width: 9,
    height: 86.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 128.8,
    y: 297.7,
    className: "st0",
    width: 9,
    height: 84.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 150.5,
    y: 297.7,
    className: "st0",
    width: 9,
    height: 84.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 172.1,
    y: 296.7,
    className: "st0",
    width: 9,
    height: 85.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 193.8,
    y: 293.7,
    className: "st0",
    width: 9,
    height: 88.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 215.4,
    y: 288.7,
    className: "st0",
    width: 9,
    height: 93.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 237,
    y: 283.7,
    className: "st0",
    width: 9,
    height: 98.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 258.7,
    y: 279.7,
    className: "st0",
    width: 9,
    height: 102.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 280.3,
    y: 266.6,
    className: "st0",
    width: 9,
    height: 115.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 302,
    y: 255.6,
    className: "st0",
    width: 9,
    height: 126.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 323.6,
    y: 243.1,
    className: "st0",
    width: 9,
    height: 138.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 345.3,
    y: 226.4,
    className: "st0",
    width: 9,
    height: 155.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 366.9,
    y: 209,
    className: "st0",
    width: 9,
    height: 172.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 388.5,
    y: 185.8,
    className: "st0",
    width: 9,
    height: 196
  }), /*#__PURE__*/React.createElement("rect", {
    x: 410.2,
    y: 160.5,
    className: "st0",
    width: 9,
    height: 221.3
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-2"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--path--inject-2",
    className: "st2",
    cx: 250,
    cy: 416.2,
    rx: 193.9,
    ry: 11.3
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "freepik--Banknotes--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M397.5,270.4c-19.2,47.7-46.5,91.7-80.8,130.1l-61.9-38.5c34.2-38.4,61.6-82.4,80.8-130.1L397.5,270.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M397.5,270.4c-19.2,47.7-46.6,91.7-80.8,130.1l-26.8-16.6l0,0l-35.2-21.8c34.2-38.4,61.6-82.4,80.8-130.1 C356.2,244.8,376.9,257.6,397.5,270.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M345.8,242.8c-1.6,4.3-6.3,6.4-10.6,4.8c-0.6-0.2-1.2-0.5-1.7-0.9c-16.9,38.6-39.3,74.6-66.4,106.8 c4,2.3,5.3,7.3,3.1,11.2c-0.3,0.6-0.7,1.1-1.2,1.6l38.6,24c3.8-4.2,10-5.2,14.9-2.4c27.1-32.3,49.4-68.3,66.4-106.9 c-4.7-3.1-6.6-9.1-4.5-14.4v-0.1L345.8,242.8L345.8,242.8z M347.6,330.6c-5.9,9.5-18.9,12.2-28.4,6.3s-12-18.2-6.1-27.7 s18.1-12.7,27.6-6.8S353.5,321,347.6,330.6L347.6,330.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M397.5,270.4c-19.2,47.7-46.6,91.7-80.8,130.1l-26.8-16.6l0,0L268.7,348C268.7,348,353.4,312.9,397.5,270.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M443.5,337.4c-39.5,33-84.3,58.9-132.7,76.6c-12.1-21-24.3-42.1-36.4-63.1c48.3-17.7,93.2-43.6,132.7-76.6 C419.2,295.3,431.4,316.4,443.5,337.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M443.5,337.4c-39.5,33-84.3,58.9-132.7,76.6c-12.1-21-24.3-42.1-36.4-63.1c48.3-17.7,93.2-43.6,132.7-76.6 C419.2,295.3,431.4,316.4,443.5,337.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M410.9,288.7c-3.4,3-8.6,2.7-11.6-0.7c-0.4-0.5-0.8-1-1.1-1.6c-33.2,26-69.9,47.2-109,62.9 c2.4,3.9,1.3,8.9-2.6,11.4c-0.5,0.3-1.1,0.6-1.8,0.8l22.7,39.4c5.3-1.9,11.3,0.2,14.3,5c39.1-15.7,75.8-36.9,109-62.9 c-2.7-5-1.5-11.2,2.8-14.9l0.1-0.1L410.9,288.7L410.9,288.7z M371,366.9c-9.8,5.6-22.4,1.9-28-7.8s-2-21.7,7.8-27.3s22-2.7,27.5,7 S380.8,361.3,371,366.9z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "freepik--Coins--inject-2"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 382,
    y: 406.3,
    className: "st3",
    width: 39,
    height: 7.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 382,
    y: 406.3,
    className: "st5",
    width: 8.6,
    height: 7.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 391.6,
    y: 406.3,
    className: "st5",
    width: 3.1,
    height: 7.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 396.6,
    y: 406.3,
    className: "st5",
    width: 2.1,
    height: 7.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 401.6,
    y: 406.3,
    className: "st5",
    width: 1.1,
    height: 7.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 408.6,
    y: 406.3,
    className: "st5",
    width: 0.5,
    height: 7.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 383.9,
    y: 398.7,
    className: "st3",
    width: 39,
    height: 7.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 383.9,
    y: 398.7,
    className: "st5",
    width: 8.6,
    height: 7.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 393.5,
    y: 398.7,
    className: "st5",
    width: 3.1,
    height: 7.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 398.5,
    y: 398.7,
    className: "st5",
    width: 2.1,
    height: 7.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 403.5,
    y: 398.7,
    className: "st5",
    width: 1.1,
    height: 7.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 410.5,
    y: 398.7,
    className: "st5",
    width: 0.5,
    height: 7.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 380.4,
    y: 391.1,
    className: "st3",
    width: 39,
    height: 7.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 380.4,
    y: 391.1,
    className: "st5",
    width: 8.6,
    height: 7.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 390,
    y: 391,
    className: "st5",
    width: 3.1,
    height: 7.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 395,
    y: 391,
    className: "st5",
    width: 2.1,
    height: 7.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 400,
    y: 391,
    className: "st5",
    width: 1.1,
    height: 7.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 407,
    y: 391,
    className: "st5",
    width: 0.5,
    height: 7.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 382,
    y: 383.4,
    className: "st3",
    width: 39,
    height: 7.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 382,
    y: 383.4,
    className: "st5",
    width: 8.6,
    height: 7.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 391.6,
    y: 383.4,
    className: "st5",
    width: 3.1,
    height: 7.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 396.6,
    y: 383.4,
    className: "st5",
    width: 2.1,
    height: 7.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 401.6,
    y: 383.4,
    className: "st5",
    width: 1.1,
    height: 7.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 408.6,
    y: 383.4,
    className: "st5",
    width: 0.5,
    height: 7.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 383,
    y: 375.8,
    className: "st3",
    width: 39,
    height: 7.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 383,
    y: 375.8,
    className: "st5",
    width: 8.6,
    height: 7.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 392.6,
    y: 375.8,
    className: "st5",
    width: 3.1,
    height: 7.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 397.6,
    y: 375.8,
    className: "st5",
    width: 2.1,
    height: 7.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 402.6,
    y: 375.8,
    className: "st5",
    width: 1.1,
    height: 7.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 409.6,
    y: 375.8,
    className: "st5",
    width: 0.5,
    height: 7.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 382,
    y: 368.2,
    className: "st3",
    width: 39,
    height: 7.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 382,
    y: 368.2,
    className: "st5",
    width: 8.6,
    height: 7.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 391.6,
    y: 368.2,
    className: "st5",
    width: 3.1,
    height: 7.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 396.6,
    y: 368.2,
    className: "st5",
    width: 2.1,
    height: 7.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 401.6,
    y: 368.2,
    className: "st5",
    width: 1.1,
    height: 7.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 408.6,
    y: 368.2,
    className: "st5",
    width: 0.5,
    height: 7.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 382,
    y: 360.6,
    className: "st3",
    width: 39,
    height: 7.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 382,
    y: 360.6,
    className: "st5",
    width: 8.6,
    height: 7.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 391.6,
    y: 360.6,
    className: "st5",
    width: 3.1,
    height: 7.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 396.6,
    y: 360.6,
    className: "st5",
    width: 2.1,
    height: 7.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 401.6,
    y: 360.6,
    className: "st5",
    width: 1.1,
    height: 7.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 408.6,
    y: 360.6,
    className: "st5",
    width: 0.5,
    height: 7.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 384,
    y: 353,
    className: "st3",
    width: 39,
    height: 7.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 384,
    y: 353,
    className: "st5",
    width: 8.6,
    height: 7.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 393.6,
    y: 353,
    className: "st5",
    width: 3.1,
    height: 7.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 398.6,
    y: 353,
    className: "st5",
    width: 2.1,
    height: 7.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 403.6,
    y: 353,
    className: "st5",
    width: 1.1,
    height: 7.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 410.6,
    y: 353,
    className: "st5",
    width: 0.5,
    height: 7.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 382,
    y: 345.3,
    className: "st3",
    width: 39,
    height: 7.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 382,
    y: 345.3,
    className: "st5",
    width: 8.6,
    height: 7.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 391.6,
    y: 345.3,
    className: "st5",
    width: 3.1,
    height: 7.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 396.6,
    y: 345.3,
    className: "st5",
    width: 2.1,
    height: 7.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 401.6,
    y: 345.3,
    className: "st5",
    width: 1.1,
    height: 7.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 408.6,
    y: 345.3,
    className: "st5",
    width: 0.5,
    height: 7.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 380,
    y: 337.7,
    className: "st3",
    width: 39,
    height: 7.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 380,
    y: 337.7,
    className: "st5",
    width: 8.6,
    height: 7.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 389.6,
    y: 337.7,
    className: "st5",
    width: 3.1,
    height: 7.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 394.6,
    y: 337.7,
    className: "st5",
    width: 2.1,
    height: 7.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 399.6,
    y: 337.7,
    className: "st5",
    width: 1.1,
    height: 7.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 406.6,
    y: 337.7,
    className: "st5",
    width: 0.5,
    height: 7.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 347.6,
    y: 406.3,
    className: "st3",
    width: 39,
    height: 7.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 347.6,
    y: 406.3,
    className: "st5",
    width: 8.6,
    height: 7.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 357.2,
    y: 406.3,
    className: "st5",
    width: 3.1,
    height: 7.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 362.2,
    y: 406.3,
    className: "st5",
    width: 2.1,
    height: 7.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 367.2,
    y: 406.3,
    className: "st5",
    width: 1.1,
    height: 7.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 374.2,
    y: 406.3,
    className: "st5",
    width: 0.5,
    height: 7.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 349.6,
    y: 398.7,
    className: "st3",
    width: 39,
    height: 7.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 349.6,
    y: 398.7,
    className: "st5",
    width: 8.6,
    height: 7.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 359.2,
    y: 398.7,
    className: "st5",
    width: 3.1,
    height: 7.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 364.2,
    y: 398.7,
    className: "st5",
    width: 2.1,
    height: 7.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 369.2,
    y: 398.7,
    className: "st5",
    width: 1.1,
    height: 7.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 376.2,
    y: 398.7,
    className: "st5",
    width: 0.5,
    height: 7.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 347.6,
    y: 391.1,
    className: "st3",
    width: 39,
    height: 7.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 347.6,
    y: 391.1,
    className: "st5",
    width: 8.6,
    height: 7.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 357.2,
    y: 391,
    className: "st5",
    width: 3.1,
    height: 7.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 362.2,
    y: 391,
    className: "st5",
    width: 2.1,
    height: 7.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 367.2,
    y: 391,
    className: "st5",
    width: 1.1,
    height: 7.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 374.2,
    y: 391,
    className: "st5",
    width: 0.5,
    height: 7.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 348.6,
    y: 383.4,
    className: "st3",
    width: 39,
    height: 7.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 348.6,
    y: 383.4,
    className: "st5",
    width: 8.6,
    height: 7.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 358.2,
    y: 383.4,
    className: "st5",
    width: 3.1,
    height: 7.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 363.2,
    y: 383.4,
    className: "st5",
    width: 2.1,
    height: 7.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 368.2,
    y: 383.4,
    className: "st5",
    width: 1.1,
    height: 7.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 375.2,
    y: 383.4,
    className: "st5",
    width: 0.5,
    height: 7.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 347.6,
    y: 375.8,
    className: "st3",
    width: 39,
    height: 7.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 347.6,
    y: 375.8,
    className: "st5",
    width: 8.6,
    height: 7.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 357.2,
    y: 375.8,
    className: "st5",
    width: 3.1,
    height: 7.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 362.2,
    y: 375.8,
    className: "st5",
    width: 2.1,
    height: 7.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 367.2,
    y: 375.8,
    className: "st5",
    width: 1.1,
    height: 7.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 374.2,
    y: 375.8,
    className: "st5",
    width: 0.5,
    height: 7.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 350.6,
    y: 368.2,
    className: "st3",
    width: 39,
    height: 7.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 350.6,
    y: 368.2,
    className: "st5",
    width: 8.6,
    height: 7.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 360.2,
    y: 368.2,
    className: "st5",
    width: 3.1,
    height: 7.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 365.2,
    y: 368.2,
    className: "st5",
    width: 2.1,
    height: 7.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 370.2,
    y: 368.2,
    className: "st5",
    width: 1.1,
    height: 7.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 377.2,
    y: 368.2,
    className: "st5",
    width: 0.5,
    height: 7.7
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "freepik--Device--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M176.1,97.5h145.7c5.7,0,10.4,4.7,10.4,10.4v295.7c0,5.7-4.7,10.4-10.4,10.4H176.1c-5.7,0-10.4-4.7-10.4-10.4 V107.9C165.7,102.2,170.4,97.5,176.1,97.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M326.6,107.5v295.9c0,2.2-1.8,4.1-4.1,4.1c0,0,0,0-0.1,0H175.1c-2,0-3.7-1.6-3.7-3.6c0-0.1,0-0.1,0-0.2V107.2 c-0.1-1.8,1.3-3.3,3.2-3.4c0,0,0,0,0,0h36.9c1.1,0,2,0.7,2.4,1.7l1.5,3.8c0.4,1,1.3,1.6,2.4,1.6h62.8c1,0,2-0.6,2.4-1.6l1.5-3.8 c0.4-1,1.3-1.6,2.4-1.7H323C325,103.8,326.7,105.5,326.6,107.5z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 171.4,
    y: 116.1,
    className: "st7",
    width: 155.3,
    height: 279.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st8",
    cx: 245.5,
    cy: 104.1,
    r: 2.1
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M252,104.1c0,0.8-0.6,1.4-1.4,1.4c-0.8,0-1.4-0.6-1.4-1.4c0-0.8,0.6-1.4,1.4-1.4c0,0,0,0,0,0 C251.4,102.8,252,103.4,252,104.1C252,104.1,252,104.1,252,104.1z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 188.9,
    y: 109.5,
    className: "st8",
    width: 1.9,
    height: 2.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 185.8,
    y: 108.6,
    className: "st8",
    width: 1.9,
    height: 3.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 182.7,
    y: 107.7,
    className: "st8",
    width: 1.9,
    height: 4.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 179.5,
    y: 106.9,
    className: "st8",
    width: 1.9,
    height: 5.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 308.4,
    y: 108.5,
    className: "st8",
    width: 1.1,
    height: 2.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 310.3,
    y: 107.6,
    className: "st8",
    width: 9.1,
    height: 4.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 171.2,
    y: 116.1,
    className: "st6",
    width: 155.5,
    height: 25.2
  }), /*#__PURE__*/React.createElement("g", {
    className: "st9"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M181.8,133.4c-0.3,0-0.5-0.1-0.7-0.3l-3.8-3.8c-0.4-0.4-0.4-1,0-1.4c0,0,0,0,0,0l3.8-3.8 c0.4-0.4,1.1-0.3,1.4,0.1c0.3,0.4,0.3,0.9,0,1.3l-3.1,3.1l3.1,3c0.4,0.4,0.4,1,0,1.4C182.3,133.3,182,133.4,181.8,133.4z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st9"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M320.9,125c0,0.6-0.5,1.1-1.1,1.1c-0.6,0-1.1-0.5-1.1-1.1c0-0.6,0.5-1.1,1.1-1.1S320.9,124.4,320.9,125 C320.9,125,320.9,125,320.9,125z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M320.9,128.6c0,0.6-0.5,1.1-1.1,1.1c-0.6,0-1.1-0.5-1.1-1.1c0-0.6,0.5-1.1,1.1-1.1S320.9,128,320.9,128.6 L320.9,128.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M320.9,132.3c0,0.6-0.5,1.1-1.1,1.1c-0.6,0-1.1-0.5-1.1-1.1c0-0.6,0.5-1.1,1.1-1.1S320.9,131.7,320.9,132.3 L320.9,132.3z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M235.5,155.4v8.4H234v-7.1h-1.8v-1.3H235.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M244,161.4c0,1.6-1.4,2.5-3.4,2.5s-3.4-1-3.4-2.5c0-0.9,0.5-1.7,1.3-2c-0.6-0.3-1-1-1-1.8 c0-1.4,1.3-2.3,3.1-2.3s3.1,0.9,3.1,2.3c0,0.7-0.4,1.4-1.1,1.8C243.5,159.7,244,160.5,244,161.4z M242.4,161.4 c0-0.8-0.7-1.3-1.9-1.3s-1.9,0.5-1.9,1.3s0.7,1.4,1.9,1.4S242.4,162.1,242.4,161.4L242.4,161.4z M239,157.6c0,0.7,0.6,1.2,1.6,1.2 s1.6-0.5,1.6-1.2s-0.6-1.2-1.6-1.2S239,156.9,239,157.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M245.1,162.9c0-0.6,0.4-1,1-1s1,0.4,1,1s-0.4,1-1,1S245.1,163.4,245.1,162.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M250.8,155.4v8.4h-1.6v-7.1h-1.8v-1.3H250.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M258.5,162.4v1.3h-6.2v-1l3.3-3.2c0.8-0.8,1-1.3,1-1.7c0-0.8-0.5-1.2-1.6-1.2c-0.8-0.1-1.5,0.3-2,0.9l-1.1-0.8 c0.8-0.9,2-1.5,3.2-1.4c1.8,0,3,0.9,3,2.4c0,1.1-0.5,2-1.4,2.6l-2.2,2.1L258.5,162.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M266.2,161.4c0,1.6-1.4,2.5-3.4,2.5s-3.4-1-3.4-2.5c0-0.9,0.5-1.7,1.3-2c-0.6-0.3-1-1-1-1.8 c0-1.4,1.3-2.3,3.1-2.3s3.1,0.9,3.1,2.3c0,0.7-0.4,1.4-1.1,1.8C265.7,159.7,266.3,160.5,266.2,161.4z M264.7,161.4 c0-0.8-0.7-1.3-1.9-1.3s-1.9,0.5-1.9,1.3s0.7,1.4,1.9,1.4S264.7,162.1,264.7,161.4L264.7,161.4z M261.2,157.7 c0,0.7,0.6,1.2,1.6,1.2s1.6-0.5,1.6-1.2s-0.6-1.2-1.6-1.2S261.2,156.9,261.2,157.7L261.2,157.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.5,208.9v4.6h-0.9v-3.9h-1v-0.7H241.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244,208.9v4.6h-0.9v-3.9h-1v-0.7H244z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.3,212.1c0,0.8-0.6,1.5-1.8,1.5c-0.6,0-1.2-0.2-1.8-0.5l0.4-0.7c0.4,0.3,0.9,0.5,1.4,0.5c0.6,0,1-0.3,1-0.7 s-0.3-0.7-1.2-0.7h-1.1l0.2-2.5h2.8v0.7h-2l-0.1,1.1h0.4C247.8,210.7,248.3,211.3,248.3,212.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.9,213.1c0,0.2-0.1,0.4-0.1,0.6l-0.3,0.9h-0.5l0.3-1c-0.2-0.1-0.3-0.3-0.3-0.5c0-0.3,0.2-0.6,0.5-0.6s0.6,0.2,0.6,0.5 C249.9,213,249.9,213,249.9,213.1L249.9,213.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.9,212.8v0.7h-3.4V213l1.9-1.8c0.3-0.2,0.5-0.6,0.5-1c0-0.4-0.3-0.7-0.9-0.7c-0.4,0-0.8,0.2-1.1,0.5l-0.6-0.5 c0.4-0.5,1.1-0.8,1.8-0.8c1,0,1.7,0.5,1.7,1.3c0,0.6-0.3,1.1-0.8,1.5l-1.2,1.2L253.9,212.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.3,211.2c0-1.5,0.8-2.4,1.9-2.4c1.1,0,2,0.9,2,2.4s-0.8,2.4-2,2.4C255.2,213.6,254.3,212.8,254.3,211.2z M257.3,211.2 c0-1.1-0.4-1.6-1.1-1.6c-0.6,0-1.1,0.5-1.1,1.6s0.4,1.6,1.1,1.6C256.9,212.9,257.4,212.4,257.3,211.2L257.3,211.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M212.8,202.7c-4.9,20,7.3,40.2,27.3,45.1c20,4.9,40.2-7.3,45.1-27.3s-7.3-40.2-27.3-45.1c0,0,0,0,0,0 C237.9,170.5,217.7,182.7,212.8,202.7C212.8,202.7,212.8,202.7,212.8,202.7z M228.2,206.5c2.8-11.5,14.4-18.5,25.9-15.7 c11.5,2.8,18.5,14.4,15.7,25.9s-14.4,18.5-25.9,15.7c0,0,0,0,0,0C232.4,229.6,225.3,218,228.2,206.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M217.2,231.1c10.8,17.6,33.7,23.1,51.3,12.3c17.6-10.8,23.1-33.7,12.3-51.3c-6.9-11.3-19.3-18-32.5-17.8 c4.4-0.1,8,3.4,8.1,7.8c0,0.7-0.1,1.4-0.3,2.1c-0.4,1.7-1.4,3.2-2.8,4.2c-1.4,1.1-3.1,1.7-4.8,1.7H248c11.8-0.6,21.9,8.6,22.4,20.4 c0.6,11.8-8.6,21.9-20.4,22.4c-7.8,0.4-15.1-3.5-19.2-10.1c-1.1-1.8-2.9-3.1-4.9-3.6c-4.2-1-8.5,1.6-9.6,5.8 C215.7,227.1,216.1,229.3,217.2,231.1L217.2,231.1z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 184.6,
    y: 275,
    className: "st3",
    width: 3.6,
    height: 11.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 193.6,
    y: 278,
    className: "st3",
    width: 3.6,
    height: 8.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 202.5,
    y: 265,
    className: "st3",
    width: 3.6,
    height: 21.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 211.4,
    y: 260,
    className: "st3",
    width: 3.6,
    height: 26.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 220.4,
    y: 265,
    className: "st3",
    width: 3.6,
    height: 21.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 229.3,
    y: 275,
    className: "st3",
    width: 3.6,
    height: 11.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 238.2,
    y: 277,
    className: "st3",
    width: 3.6,
    height: 9.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 247.2,
    y: 278,
    className: "st3",
    width: 3.6,
    height: 8.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 256.1,
    y: 275,
    className: "st3",
    width: 3.6,
    height: 11.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 265.1,
    y: 270,
    className: "st3",
    width: 3.6,
    height: 16.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 274,
    y: 266,
    className: "st3",
    width: 3.6,
    height: 20.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 282.9,
    y: 262,
    className: "st3",
    width: 3.6,
    height: 24.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 291.9,
    y: 257,
    className: "st3",
    width: 3.6,
    height: 29.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 300.8,
    y: 264,
    className: "st3",
    width: 3.6,
    height: 22.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 309.7,
    y: 275,
    className: "st3",
    width: 3.6,
    height: 11.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 202.5,
    y: 265,
    className: "st6",
    width: 3.6,
    height: 5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 211.4,
    y: 260,
    className: "st6",
    width: 3.6,
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 220.4,
    y: 265,
    className: "st6",
    width: 3.6,
    height: 5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 274,
    y: 266,
    className: "st6",
    width: 3.6,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 282.9,
    y: 262,
    className: "st6",
    width: 3.6,
    height: 8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 291.9,
    y: 257,
    className: "st6",
    width: 3.6,
    height: 13
  }), /*#__PURE__*/React.createElement("rect", {
    x: 300.8,
    y: 264,
    className: "st6",
    width: 3.6,
    height: 6
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M184.7,301h128.5c1.6,0,3,1.3,3,3v15.3c0,1.6-1.3,3-3,3H184.7c-1.6,0-3-1.3-3-3V304 C181.7,302.3,183.1,301,184.7,301z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "st9"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M282.7,311.6h-1.2v1.2h-0.7v-1.2h-1.2v-0.7h1.2v-1.2h0.7v1.2h1.2V311.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M287.4,313.6v0.8h-0.5v-0.7c-0.6,0-1.2-0.2-1.6-0.5l0.3-0.7c0.4,0.3,0.8,0.5,1.3,0.5v-1.3 c-0.7-0.2-1.5-0.4-1.5-1.3c0-0.7,0.5-1.3,1.5-1.4v-0.8h0.5v0.7c0.5,0,0.9,0.2,1.4,0.4l-0.3,0.7c-0.3-0.2-0.7-0.3-1.1-0.4v1.4 c0.7,0.2,1.5,0.4,1.5,1.3C288.9,313,288.5,313.5,287.4,313.6z M286.9,310.8v-1.2c-0.5,0.1-0.7,0.3-0.7,0.6 S286.5,310.7,286.9,310.8z M288.1,312.3c0-0.3-0.3-0.5-0.7-0.6v1.2C287.9,312.8,288.1,312.6,288.1,312.3L288.1,312.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M294.8,308.9v0.6l-1.8,4.1h-0.9l1.8-3.9H292v0.8h-0.8v-1.5H294.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M298.6,312.2c0,0.8-0.6,1.5-1.8,1.5c-0.6,0-1.2-0.2-1.8-0.5l0.4-0.7c0.4,0.3,0.9,0.5,1.4,0.5 c0.6,0,1-0.3,1-0.7s-0.3-0.7-1.2-0.7h-1.1l0.2-2.5h2.7v0.7h-2l-0.1,1.1h0.4C298.1,310.7,298.6,311.3,298.6,312.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M300.2,313.1c0,0.2-0.1,0.4-0.1,0.6l-0.3,0.9h-0.5l0.3-1c-0.2-0.1-0.3-0.3-0.3-0.5c0-0.3,0.2-0.6,0.5-0.6 c0.3,0,0.6,0.2,0.6,0.5C300.2,313,300.2,313,300.2,313.1L300.2,313.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M300.6,311.3c0-1.5,0.8-2.4,1.9-2.4s2,0.9,2,2.4s-0.8,2.4-2,2.4S300.6,312.8,300.6,311.3z M303.6,311.3 c0-1.1-0.4-1.6-1.1-1.6s-1.1,0.5-1.1,1.6s0.4,1.6,1.1,1.6S303.7,312.4,303.6,311.3L303.6,311.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M308.5,312.2c0,0.8-0.6,1.5-1.8,1.5c-0.6,0-1.2-0.2-1.8-0.5l0.4-0.7c0.4,0.3,0.9,0.5,1.4,0.5 c0.6,0,1-0.3,1-0.7s-0.3-0.7-1.2-0.7h-1.1l0.2-2.5h2.7v0.7h-2l-0.1,1.1h0.4C308,310.7,308.5,311.3,308.5,312.2z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M222.8,310h-31.3c-0.7,0-1.2-0.5-1.2-1.2l0,0l0,0c0-0.7,0.5-1.2,1.2-1.2c0,0,0,0,0,0h31.3 c0.7,0,1.2,0.5,1.2,1.2l0,0C223.9,309.5,223.4,310,222.8,310z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M208.8,315.6h-17.3c-0.7,0-1.2-0.5-1.2-1.2c0,0,0,0,0,0l0,0c0-0.7,0.5-1.2,1.2-1.2l0,0h17.3 c0.7,0,1.2,0.5,1.2,1.2l0,0C210,315.1,209.4,315.6,208.8,315.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M184.7,330h128.5c1.6,0,3,1.3,3,3v15.3c0,1.6-1.3,3-3,3H184.7c-1.6,0-3-1.3-3-3V333 C181.7,331.3,183.1,330,184.7,330z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "st9"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M280.4,340.4h1.8v0.7h-1.8V340.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M286.9,342.6v0.8h-0.5v-0.7c-0.6,0-1.2-0.2-1.6-0.5l0.3-0.7c0.4,0.3,0.8,0.5,1.3,0.5v-1.3 c-0.7-0.2-1.5-0.4-1.5-1.3c0-0.7,0.5-1.3,1.5-1.4v-0.8h0.5v0.7c0.5,0,0.9,0.2,1.4,0.4L288,339c-0.3-0.2-0.7-0.3-1.1-0.4v1.4 c0.7,0.2,1.5,0.4,1.5,1.3C288.4,342,287.9,342.5,286.9,342.6z M286.3,339.8v-1.2c-0.5,0.1-0.7,0.3-0.7,0.6 S285.9,339.7,286.3,339.8z M287.6,341.3c0-0.3-0.3-0.5-0.7-0.6v1.2C287.4,341.8,287.6,341.6,287.6,341.3L287.6,341.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M294.2,341.2c0,0.8-0.6,1.5-1.9,1.5c-0.6,0-1.2-0.2-1.8-0.5l0.4-0.7c0.4,0.3,0.9,0.5,1.4,0.5 c0.6,0,1-0.3,1-0.7s-0.3-0.7-1.2-0.7h-1.1l0.2-2.5h2.7v0.7h-2l-0.1,1.1h0.5C293.6,339.7,294.2,340.3,294.2,341.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M298,341.2c0,0.8-0.6,1.5-1.9,1.5c-0.6,0-1.2-0.2-1.8-0.5l0.4-0.7c0.4,0.3,0.9,0.5,1.4,0.5 c0.6,0,1-0.3,1-0.7s-0.3-0.7-1.3-0.7h-1.1l0.2-2.5h2.7v0.7h-2l-0.1,1.1h0.5C297.5,339.7,298,340.3,298,341.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M299.6,342.1c0,0.2-0.1,0.4-0.1,0.6l-0.3,0.9h-0.5l0.3-1c-0.2-0.1-0.3-0.3-0.3-0.5c0-0.3,0.2-0.5,0.5-0.5 c0,0,0,0,0.1,0C299.3,341.5,299.6,341.8,299.6,342.1C299.6,342.1,299.6,342.1,299.6,342.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M304.2,341.5h-0.8v1.1h-0.8v-1.1H300v-0.6l2.3-3h0.9l-2.2,2.9h1.5v-0.9h0.8v0.9h0.8L304.2,341.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M308.5,341.2c0,0.9-0.8,1.4-1.9,1.4s-1.9-0.5-1.9-1.4c0-0.5,0.3-0.9,0.7-1.1c-0.4-0.2-0.6-0.6-0.6-1 c0-0.8,0.7-1.3,1.7-1.3s1.8,0.5,1.8,1.3c0,0.4-0.2,0.8-0.6,1C308.2,340.3,308.5,340.8,308.5,341.2z M307.6,341.2 c0-0.5-0.4-0.8-1-0.8s-1,0.3-1,0.8s0.4,0.8,1,0.8S307.6,341.7,307.6,341.2L307.6,341.2z M305.7,339.2c0,0.4,0.3,0.7,0.9,0.7 s0.9-0.3,0.9-0.7s-0.4-0.7-0.9-0.7S305.7,338.8,305.7,339.2L305.7,339.2z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M222.8,339h-31.3c-0.7,0-1.2-0.5-1.2-1.2l0,0l0,0c0-0.7,0.5-1.2,1.2-1.2c0,0,0,0,0,0h31.3 c0.7,0,1.2,0.5,1.2,1.2l0,0C223.9,338.5,223.4,339,222.8,339z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M208.8,344.6h-17.3c-0.7,0-1.2-0.5-1.2-1.2c0,0,0,0,0,0l0,0c0-0.7,0.5-1.2,1.2-1.2l0,0h17.3 c0.7,0,1.2,0.5,1.2,1.2l0,0C210,344.1,209.4,344.6,208.8,344.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M184.7,359h128.5c1.6,0,3,1.3,3,3v15.3c0,1.6-1.3,3-3,3H184.7c-1.6,0-3-1.3-3-3V362 C181.7,360.3,183.1,359,184.7,359z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "st9"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M283.5,369.6h-1.2v1.2h-0.7v-1.2h-1.2v-0.7h1.2v-1.2h0.7v1.2h1.2V369.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M288.2,371.6v0.8h-0.5v-0.7c-0.6,0-1.2-0.2-1.6-0.5l0.3-0.7c0.4,0.3,0.8,0.5,1.3,0.5v-1.3 c-0.7-0.2-1.5-0.4-1.5-1.3c0-0.7,0.5-1.3,1.5-1.4v-0.8h0.5v0.7c0.5,0,0.9,0.2,1.4,0.4l-0.3,0.7c-0.3-0.2-0.7-0.3-1.1-0.4v1.4 c0.7,0.2,1.5,0.4,1.5,1.3C289.7,371,289.2,371.5,288.2,371.6z M287.6,368.8v-1.2c-0.5,0.1-0.7,0.3-0.7,0.6 S287.2,368.7,287.6,368.8L287.6,368.8z M288.9,370.3c0-0.3-0.3-0.5-0.7-0.6v1.2C288.6,370.8,288.9,370.6,288.9,370.3L288.9,370.3z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M293.7,366.9v4.7h-0.9v-3.9h-1v-0.7H293.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M298.4,370.2c0,0.9-0.8,1.4-1.9,1.4s-1.9-0.5-1.9-1.4c0-0.5,0.3-0.9,0.7-1.1c-0.4-0.2-0.6-0.6-0.6-1 c0-0.8,0.7-1.3,1.7-1.3s1.8,0.5,1.8,1.3c0,0.4-0.2,0.8-0.6,1C298.1,369.3,298.4,369.8,298.4,370.2z M297.5,370.2 c0-0.5-0.4-0.8-1-0.8s-1,0.3-1,0.8s0.4,0.8,1,0.8S297.5,370.7,297.5,370.2L297.5,370.2z M295.6,368.2c0,0.4,0.3,0.7,0.9,0.7 s0.9-0.3,0.9-0.7s-0.4-0.7-0.9-0.7S295.6,367.8,295.6,368.2L295.6,368.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M300.1,371.1c0,0.2-0.1,0.4-0.1,0.6l-0.3,0.9H299l0.3-1c-0.2-0.1-0.3-0.3-0.3-0.5c0-0.3,0.2-0.5,0.5-0.5 C299.8,370.5,300,370.8,300.1,371.1C300,371.1,300,371.1,300.1,371.1L300.1,371.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M304.1,370.9v0.7h-3.4V371l1.9-1.8c0.5-0.4,0.5-0.7,0.5-1c0-0.4-0.3-0.7-0.9-0.7c-0.4,0-0.8,0.2-1.1,0.5 l-0.6-0.5c0.4-0.5,1.1-0.8,1.8-0.8c1,0,1.7,0.5,1.7,1.3c0,0.6-0.3,1.1-0.8,1.5l-1.2,1.2L304.1,370.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M304.5,369.3c0-1.5,0.8-2.4,1.9-2.4s2,0.9,2,2.4s-0.8,2.4-2,2.4S304.5,370.8,304.5,369.3z M307.5,369.3 c0-1.1-0.4-1.6-1.1-1.6s-1.1,0.5-1.1,1.6s0.4,1.6,1.1,1.6S307.6,370.4,307.5,369.3L307.5,369.3z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M222.8,368h-31.3c-0.7,0-1.2-0.5-1.2-1.2l0,0l0,0c0-0.7,0.5-1.2,1.2-1.2c0,0,0,0,0,0h31.3 c0.7,0,1.2,0.5,1.2,1.2l0,0C223.9,367.5,223.4,368,222.8,368z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M208.8,373.6h-17.3c-0.7,0-1.2-0.5-1.2-1.2c0,0,0,0,0,0l0,0c0-0.7,0.5-1.2,1.2-1.2l0,0h17.3 c0.7,0,1.2,0.5,1.2,1.2l0,0C210,373.1,209.4,373.6,208.8,373.6z"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--group--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M108,195.9c0.1,0.4-0.2,0.8-0.7,0.9c-0.1,0-0.1,0-0.2,0l-9.2-0.2c-0.5,0-0.9-0.4-1-0.9l-1.6-18.1 c0-0.5,0.3-1,0.9-1c0,0,0,0,0,0l9.1,0.2c0.5,0.1,1,0.5,1,1.1L108,195.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M105.4,177.6l1.6,18.3c0.1,0.4-0.1,0.7-0.5,0.8c-0.1,0-0.1,0-0.2,0l-7.7-0.2c-0.5,0-1.5-0.3-1.5-0.8 l-1.6-18.3c0-0.5,0.9-0.9,1.4-0.9l7.7,0.2C105.1,176.7,105.4,177.1,105.4,177.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M102.3,200.8l-1.1-3.5c0.5-1.3,0.8-2.6,1.1-3.9c0.1-1.2-3.1-10.4-3.1-10.4s-3.5,2.7-5.5,4.1 s1.2,10.3,1.8,10.6s1.5,0.8,1.5,0.8l0.7,2.9L102.3,200.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M96.6,204.1c1.1,4.1,5.7,20.9,11.2,23.1c1.4,0.6,3.2,0.2,5-0.7c6-3.1,12.8-12.5,12.8-12.5l-1.4-6.8l-1.3-6.4 c-5,2.5-10.8,14.5-12.3,14.4c-1.3-0.1-4.7-10.4-5.7-13.5c-0.2-0.5-0.7-0.8-1.2-0.6l-6.5,1.8C96.8,203,96.5,203.6,96.6,204.1z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "102.7,198.9 103.2,201.2 97.3,202.9 96.6,200.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "102.7,198.9 103.2,201.2 97.3,202.9 96.6,200.4  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M112.8,226.5c6-3.1,12.8-12.5,12.8-12.5l-1.4-6.8C121.1,210.1,113.8,217.7,112.8,226.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M158.2,328.9l-0.1-8.7c0-0.3,0.2-0.5,0.5-0.6l6.4-1.5c0.6-0.1,1.1,0.2,1.3,0.8c0,0.1,0,0.2,0,0.2 c0,2.8-0.2,4.9-0.2,8.4c0,2.2,0.3,8.8,0.3,11.8s-3,3.4-3.2,2.2c-1.2-5.5-2.9-9.7-4.5-11.5C158.4,329.7,158.2,329.3,158.2,328.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M119.2,248.5l-2.8,14.8c0,0-22.3,36.1-22.3,56.9c0,24.9,64.9,10.5,64.9,10.5v-11.5c0,0-38.8,3.3-42.3-0.5 c-4.2-4.7,21.9-41.3,21.9-41.3L119.2,248.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M94.1,320.2c0,13.7,19.7,15.5,37.5,14.4c8.8-0.6,17.6-1.8,26.3-3.6c0.8-0.1,1.2-0.2,1.2-0.2v-11.5l-1.4,0.1 c-4.4,0.4-18.1,1.4-28.5,1.2c-6.2-0.1-11.2-0.6-12.3-1.9c-2.1-2.3,3.2-12.3,9.1-21.9l0,0c6.1-9.9,12.9-19.4,12.9-19.4l-8.5-12.7 l-10.9-16.2l-2.8,14.8C116.4,263.3,94.1,299.3,94.1,320.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M129.1,320.5l2.5,14c8.8-0.6,17.6-1.8,26.3-3.6l-0.2-11.6C153.2,319.7,139.5,320.7,129.1,320.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M130.1,280.5c0,0-3.6,8.5-4.3,16.2c6.1-9.9,12.9-19.4,12.9-19.4l-8.5-12.7l-4.5-1.5 C125.7,263.2,124.7,269.1,130.1,280.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M135.9,405.8h8.7c0.3,0,0.6,0.2,0.6,0.5l1.4,6.4c0.1,0.6-0.2,1.1-0.8,1.2c0,0,0,0,0,0c-0.1,0-0.2,0-0.2,0 c-2.8,0-4.9-0.2-8.4-0.2c-2.2,0-8.8,0.2-11.8,0.2s-3.4-3-2.2-3.3c5.5-1.2,9.7-2.9,11.5-4.5C135,405.9,135.5,405.8,135.9,405.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M158.1,248.9c0,0,1.9,7.2,0,40.5c-3,51-12.4,118.8-12.4,118.8l-11-2c0,0,1.4-101.5-0.1-129.5 c0,0-15.5-13.9-15.4-28.2S158.1,248.9,158.1,248.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M158.1,248.9c0,0,1.9,7.2,0,40.5c-3,51-12.4,118.8-12.4,118.8l-11-2c0,0,1.4-101.5-0.1-129.5 c0,0-15.5-13.9-15.4-28.2S158.1,248.9,158.1,248.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M118.4,247.5c0,0.7,0.6,1.3,1.3,1.3c0,0,0,0,0,0l36.2,0.8l2.6,0.1c0.7,0,1.3-0.5,1.3-1.2l0.7-9.5l0.4-5.1 l1.9-24.4l0.4-5.2c-17.7-13.2-40.2-3.4-40.2-3.4C118.9,213.5,118.5,240.6,118.4,247.5z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "159.1,249.5 118.7,248.3 118.2,250.7 159.1,252  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "159.1,249.5 118.7,248.3 118.2,250.7 159.1,252  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M160.9,233.8l1.9-24.4c-1.1,0.4-2.1,0.9-3,1.7C159.8,211,153.4,220.9,160.9,233.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M155.9,249.6l2.6,0.1c0.7,0,1.3-0.5,1.3-1.2l0.7-9.5C158.7,242.4,157.2,246,155.9,249.6z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "st9"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M122.6,220.5l0.4-1.2c0.6,0.4,1.3,0.6,2,0.6c0.8,0,1.2-0.3,1.1-0.8c-0.1-1.2-3.4,0.1-3.5-2.5 c0-1.2,0.8-2,2.3-2.1c0.7,0,1.5,0.1,2.1,0.5l-0.4,1.2c-0.5-0.3-1-0.4-1.6-0.4c-0.8,0-1.2,0.4-1.1,0.8c0.1,1.3,3.4,0,3.5,2.5 c0.1,1.2-0.9,2-2.4,2.1C124.1,221.2,123.3,221,122.6,220.5z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M150.7,200.5c-3.5,3.2-12,2-12,2s-5.3-1.5-4.2-3.1c3.1-0.5,4.7-2,5.3-3.9c0.3-1.2,0.4-2.4,0.3-3.6 c0-0.7-0.1-1.3-0.3-2l10.6-7.8C149,187.3,147.3,196.8,150.7,200.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M147.9,187.1c-0.4,6.3-5.6,8.1-8.2,8.4c0.3-1.2,0.4-2.4,0.3-3.6L147.9,187.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M153.9,165.7c0,0,2.9,9.5-1.7,14.1s-7.3-13.6-7.3-13.6L153.9,165.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M138.4,189.7c2.7,2.9,7.1,3.7,10.6,1.9c2.3-1.1,4-3.1,4.9-5.4c0.1-0.3,0.2-0.7,0.3-1 c1.6-6.3,0.9-16.9-6-19.8c-4.9-2.1-10.6,0.1-12.8,5c0,0,0,0,0,0c-0.6,1.4-0.9,2.9-0.8,4.4C135,181.9,134.8,186.1,138.4,189.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M145.4,177c0,0.6,0.3,1.1,0.7,1.1s0.7-0.4,0.7-1s-0.3-1.1-0.7-1.1S145.5,176.4,145.4,177z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M152,177.1c-0.1,0.6,0.3,1.1,0.7,1.1s0.7-0.5,0.7-1s-0.3-1.1-0.7-1.1S152,176.6,152,177.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M149.9,177.4c0.6,1.8,1.5,3.5,2.7,5c-0.8,0.6-1.8,0.7-2.8,0.5L149.9,177.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M143.5,174.9c0.1,0,0.3,0,0.3-0.1c0.5-0.7,1.3-1.1,2.2-1.1c0.2,0,0.3-0.2,0.3-0.4c0-0.1-0.1-0.3-0.3-0.3l0,0 c-1.1,0-2.1,0.5-2.8,1.3c-0.1,0.1-0.1,0.3,0,0.5c0,0,0,0,0,0l0,0C143.3,174.8,143.4,174.8,143.5,174.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M154.8,174.9c0.1,0,0.1,0,0.2,0c0.2-0.1,0.3-0.3,0.2-0.4l0,0c-0.4-1-1.3-1.8-2.4-2c-0.2,0-0.4,0.1-0.4,0.3 l0,0c0,0.2,0.1,0.4,0.3,0.4l0,0c0.8,0.2,1.5,0.8,1.9,1.6C154.6,174.8,154.7,174.9,154.8,174.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M140.1,166.1l0.5,3.1c-1.1,0.6-1.6,1.9-1.1,3c1.1,2.6-0.3,6.7-2.3,8.4c0,0-0.1-1.1-1-0.8s-0.5,6.2,1.4,9 c-2.5-2.6-4.3-5.7-5.1-9.2c-1.6-5.7-1.5-9.9-0.4-12.2L140.1,166.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M131.5,180.6c0.8,1.6,2.1,2.9,3.8,3.5c2.2,0.8,3.5-1.1,3-3.3c-0.4-1.9-2.1-4.8-4.4-4.6 c-1.7,0.1-2.9,1.6-2.8,3.2C131.2,179.7,131.3,180.2,131.5,180.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M149,184.9c-0.8,0.8-1.5,1.6-2.1,2.4l-0.5-0.3c-2.3-1.2-2.9-2.5-3-3.6c0-0.5,0.1-1.1,0.3-1.5 c0.1-0.3,0.3-0.5,0.5-0.8c1.1,1.4,2.4,2.5,4,3.3C148.7,184.8,149,184.9,149,184.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M148.2,184.5l-0.6,0.7c-2.1-1.1-3.5-2.2-3.8-3.2c0.1-0.3,0.3-0.5,0.5-0.8 C145.3,182.6,146.6,183.7,148.2,184.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M146.4,187.1c-2.3-1.2-2.9-2.5-3-3.6c0.9,0.5,1.6,1.1,2.3,1.8C146,185.8,146.3,186.4,146.4,187.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M131.2,172c-0.5-3.3,0.8-6.7,3.5-8.8c4.6-3.9,17.7-5.7,19.7,0s-7.7,10.9-14.7,5.9L131.2,172z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M149.5,195.7l-10.1,4.6l-0.6-3.7l-3.8,1.3c-1.3,0.5-2.2,1.8-2,3.2l0.4,4l5.1-2.8l2.6,3.6l12.2-5.9 L149.5,195.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M149.5,195.7l-10.1,4.6l-0.6-3.7l-3.8,1.3c-1.3,0.5-2.2,1.8-2,3.2l0.4,4l5.1-2.8l2.6,3.6l12.2-5.9 L149.5,195.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M151.1,252c0,0,0.2,5.4,7.2,7.7c0.2-2.6,0-5.2-0.6-7.8L151.1,252z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M163.1,204.2c6.2,6,15.4,25.2,12.7,33.5c-2.3,7.1-13.1,17.7-16.3,20.7c-0.5,0.5-1.2,0.4-1.7,0c0,0,0,0,0,0 l-3.8-4.2c-0.4-0.4-0.4-1.1-0.1-1.5c2.5-3.3,11.9-15.9,12.6-18.5c0.7-3-7.3-14.6-7.3-14.6c-0.7-3.4-0.8-6.8-0.1-10.2 C160.1,204.1,163.1,204.2,163.1,204.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M153.7,253.7l-1.4,1.4c0,0,2.2,3.3,4.8,4l0.7-0.7L153.7,253.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M153.7,253.7l-1.4,1.4c0,0,2.2,3.3,4.8,4l0.7-0.7L153.7,253.7z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg06BankingApp);
export default __webpack_public_path__ + "static/media/06_banking_app.caa87e83a570b9ba7f1a9aed50121a99.svg";
export { ForwardRef as ReactComponent };